export default __webpack_public_path__ + "static/media/hack-o-relay-video.5c9c01af.mp4";